import { deserialize, serializable } from 'serializr';

export class YouTrackProjectModel {
  @serializable
  public id: string;
  @serializable
  public shortName: string;
  @serializable
  public name: string;
  @serializable
  public projectKey: string;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(YouTrackProjectModel, input));
  }
}

export class YouTrackIssueModel {
  @serializable
  public id: string;
  @serializable
  public summary: string;
  @serializable
  public idReadable: string;
  @serializable
  public description: string;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(YouTrackIssueModel, input));
  }
}
